import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'group-ko-map-game-table',
  templateUrl: 'map-game-table.html',
})
export class GroupKoGameTablePage {
  gamePlanList: IGamePlan[] = [];

  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(
    private navParams: NavParams
  ) { }

  onEditTeam(i: number, j: number) {
    this.onEdit.emit({ i: i, j: j });
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-group-ko/map-game-table/map-game-table.ts